const FIRST_MONTH = { year: 2025, monthIndex: 8 };
const LAST_MONTH = { year: 2027, monthIndex: 7 };

export function generateTeacherPerformanceMonths(locale = 'lt-LT') {
    const months = [];
    let year = FIRST_MONTH.year;
    let monthIndex = FIRST_MONTH.monthIndex;

    while (year < LAST_MONTH.year || (year === LAST_MONTH.year && monthIndex <= LAST_MONTH.monthIndex)) {
        const date = new Date(year, monthIndex, 1);

        months.push({
            value: `${year}-${String(monthIndex + 1).padStart(2, '0')}`,
            label: date.toLocaleDateString(locale, { month: 'long', year: 'numeric' })
        });

        monthIndex += 1;
        if (monthIndex === 12) {
            monthIndex = 0;
            year += 1;
        }
    }

    return months;
}
